import { AdvertisementTypeEnum } from "@app/types/enums";

export const smxPrebidScript =
  "https://adtag.sphdigital.com/tag/smx/smx_prebid.js";

export const ADS_TO_DISABLE_IN_PLAYWRIGHT = [
  AdvertisementTypeEnum.LB1,
  AdvertisementTypeEnum.CATFISH,
];
